import {Dropdown, Toggle} from '@/components/atoms'
import {usePromotion} from '@/context/Promotion/PromotionContext'
import {PromotionType} from '@/types/promotion'
import {DropdownItem} from 'pepsico-ds'
import {useState} from 'react'
import PromotionSelectionModal from '../PromotionSelectionModal'

const defaultExcludedItems = []

export const ExcludeProducts = ({ModalComponent = PromotionSelectionModal}) => {
  const {promotionConfig, promotion, promotionType, onResultChange, isLoadingConfig} = usePromotion()
  const {conditions} = promotionConfig
  // Filter out the ANY option from the dropdown
  const buyTypeOptions = (conditions?.itemTypeOptions ?? []).filter(option => option.id !== 'ANY')
  const {excludedItems} = promotion

  const excludedItem = excludedItems?.[0] || {items: [], itemType: ''}

  const [excludeProducts, setExcludeProducts] = useState(() => {
    return excludedItem.items?.length > 0
  })

  const [excludedModalProps, setExcludedModalProps] = useState({show: false, type: ''})

  const buyTypesIds = buyTypeOptions?.map(item => item.id)

  const exludedValues = excludedItem?.items.map(item => ({id: item.id, displayText: item.name})) ?? []

  const handleCloseModal = () => {
    setExcludedModalProps(prev => ({...prev, show: false}))
  }

  const handleValues = (selectedItems: {values: DropdownItem[]; itemType: string}) => {
    const {values, itemType} = selectedItems || {}
    if (!values || !Array.isArray(values)) {
      clearValues()
      return
    }
    const items = values?.map(item => ({id: item.id, name: item.displayText})) || []
    onResultChange({
      excludedItems: [{items, itemType}],
    })
  }

  const handleSubmitModal = (selectedItems: {values: DropdownItem[]; itemType: string}) => {
    handleValues(selectedItems)
    handleCloseModal()
  }

  const clearValues = () => {
    onResultChange({excludedItems: defaultExcludedItems})
  }

  const handleToggle = checked => {
    setExcludeProducts(checked)
    if (!checked) {
      clearValues()
    }
  }

  const handleSelectedExludedType = (values: DropdownItem[]) => {
    if (!values || !values.length) {
      clearValues()
      return
    }

    const isModalValue = values.find(item => buyTypesIds.includes(item.id))
    if (isModalValue) {
      setExcludedModalProps({show: true, type: isModalValue.id})
    } else {
      // Directly update when user adds/removes regular items
      handleValues({values, itemType: excludedItem?.itemType || ''})
    }
  }

  const selectedValuesText = exludedValues?.map(item => item.displayText).join(', ')

  return (
    <>
      {![PromotionType.STORE_DISCOUNT, PromotionType.WELCOME_DISCOUNT].includes(promotionType) && (
        <Toggle
          updateValue={handleToggle}
          value={excludeProducts}
          uiSchema={{size: 'small', label: 'Exclude', isDark: true}}
        />
      )}
      {excludeProducts && (
        <>
          <Dropdown
            isJsonWrap={false}
            childList={buyTypeOptions}
            placeholder={selectedValuesText || 'Any'}
            value={exludedValues}
            updateValue={handleSelectedExludedType}
            isClearable={true}
            autocomplete="off"
            selection="multiple"
            loading={isLoadingConfig}
          />
          <ModalComponent
            key={JSON.stringify(excludedModalProps)}
            show={excludedModalProps.show}
            type={excludedModalProps.type}
            onClose={handleCloseModal}
            onSubmit={handleSubmitModal}
            conditionValues={{
              itemType: excludedItem?.itemType,
              values: exludedValues || [],
            }}
            isExclude={true}
          />
        </>
      )}
    </>
  )
}
